import { ensureBundledocsActionCompleted } from './ensureBundledocsActionCompleted'

const BUNDLEDOCS_BASE_URL = 'https://app.bundledocs.com/#!'

export const openInBundledocs = async (bundleData: any) => {
  await ensureBundledocsActionCompleted(bundleData, () => {
    window.open(`${BUNDLEDOCS_BASE_URL}/bundle/${bundleData.bundledocsPartitionKey}/${bundleData?.bundledocsRowKey}`, '_blank', 'noopener,noreferrer')
  })
}
